import { App } from 'antd';
import { useCallback } from 'react';

export function useHandleResponse() {
  const { message } = App.useApp(); // ✅ hook used at component top-level

  return useCallback(
    (data: any, successMessage?: string) => {
      const errors = data?.errors;
      if (Array.isArray(errors) && errors.length) {
        errors.forEach((err: any) => message.error(String(err)));
        return;
      }
      message.success(
        <span>
          <span className='font-weight-bold'>{successMessage}</span>
          {' a fost adăugat/modificat cu succes.'}
        </span>
      );
    },
    [message]
  );
}
